import { AuthRawReturn } from '@/modules/Auth/apiTypes/base'
import { APIRoute } from '@/modules/utils'

export type ClassicBody = {
  email: string
  password: string
}

export const ClassicRoute: APIRoute = {
  method: 'POST',
  path: '/v2/auth',
}

export type SSOBody = {
  email: string
  sso: string
}

export type Body = ClassicBody | SSOBody

export type Response = AuthRawReturn

export const SSORoute: APIRoute = {
  method: 'POST',
  path: '/v2/auth/sso',
}
